/**
 * React Context + useAuth only — no service imports.
 * Import this from consumers (e.g. ActiveRoleContext) instead of AuthContext.tsx
 * to avoid circular module graphs that can yield a second createContext() instance
 * ("useAuth must be used within AuthProvider" while the tree shows AuthProvider).
 */
import { createContext, useContext } from 'react';
import type { AuthContextType } from './authContext.types';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
